<template>
  <modal :show="true" :large="true" v-on:close="closeModal">
    <div slot="title">
      <h4>Add Witness</h4>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <selectlist
            :options="titles"
            v-model="form.title_id"
            label="Title"
            placeholder="Please Select"
            name="title_id"
          ></selectlist>

          <inputbox
            v-model="form.first_name"
            name="first_name"
            label="First Name"
          ></inputbox>

          <inputbox
            v-model="form.last_name"
            name="last_name"
            label="Last Name"
          ></inputbox>

          <inputbox
            v-model="form.telephone"
            name="telephone"
            label="Telephone"
          ></inputbox>

          <inputbox
            v-model="form.email_address"
            name="email"
            label="Email Address"
            type="email"
          ></inputbox>

          <address-lookup
            :address="address"
            v-on:address="setAddress"
          ></address-lookup>

          <toggleswitch
            :labels="true"
            name="corroborate"
            label="Corroborate Clients Version of Events?"
            v-model="form.corroborate"
          ></toggleswitch>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button type="button" v-on:click="closeModal" class="btn btn-danger">
        Close
      </button>
      <button v-on:click="addWitness" type="button" class="btn btn-primary">
        Add New Witness
      </button>
    </div>
  </modal>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },

    titles: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      form: new window.Form({
        title_id: null,
        first_name: null,
        last_name: null,
        telephone: null,
        email_address: null,
        address_line_one: null,
        address_line_two: null,
        city: null,
        postcode: null,
        corroborate: true
      })
    };
  },

  computed: {
    address() {
      return {
        address_line_one: this.form.address_line_one,
        address_line_two: this.form.address_line_two,
        city: this.form.city,
        postcode: this.form.postcode
      };
    }
  },

  methods: {
    setAddress(address) {
      this.form.address_line_one = address.address_line_one;
      this.form.address_line_two = address.address_line_two;
      this.form.city = address.city;
      this.form.postcode = address.postcode;
    },

    closeModal() {
      this.$emit('close');
    },

    addWitness() {
      this.form
        .post('/incidents/' + this.incident + '/witnesses')
        .then(response => {
          this.$emit('added', response);
        })
        .catch(error => {});
    }
  }
};
</script>
